import {
	Autocomplete,
	AutocompleteChangeReason,
	TextField,
} from "@mui/material"
import { SyntheticEvent, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { CampaignsState } from "../../../store/actions/campaigns"
import { CorporateEssential } from "../../../store/actions/corporates"
import { RootState } from "../../../store/reducers"

interface ICampaignAutoCompleteProps {
	filterCorporate: string | undefined
	filterCampaign: string | undefined
	setFilterCampaign: (campaign: string | undefined) => void
}

const CampaignAutoComplete = ({
	filterCorporate,
	filterCampaign,
	setFilterCampaign,
}: ICampaignAutoCompleteProps) => {
	const { t } = useTranslation()
	const corporatesState: CorporateEssential[] = useSelector(
		(state: RootState) => state.corporatesUser.list
	)
	const corporateSelectedState: CorporateEssential | undefined = useSelector(
		(state: RootState) => state.corporatesUser.selected
	)
	const [campaignListOptions, setCampaignListOptions] = useState<
		[] | { label: string; value: string }[]
	>([])
	const [campaignOptionSelected, setCampaignOptionSelected] = useState<{
		label: string
		value: string
	} | null>(null)

	useEffect(() => {
		const arrayCampaignOption: {
			label: string | undefined
			value: string | undefined
		}[] = []
		/**
		 * if corporate is selected I have to list campaign owned by that corporate
		 * otherwise all campaign of bank is listed
		 */
		let campaignsArray: CampaignsState[] = []
		if (filterCorporate) {
			const item = corporatesState?.find(
				(entry) => entry.id === filterCorporate
			)
			if (item) {
				campaignsArray = item.campaigns
			}
		} else {
			campaignsArray = corporateSelectedState?.campaigns || []
		}

		campaignsArray?.map((campaign: CampaignsState) => {
			if (campaign.enabled) {
				arrayCampaignOption.push({
					label: campaign.campaignName,
					value: campaign.idLogo,
				})
			}
			return campaignsArray
		})

		/*
		const campaignsArray: CampaignsState[] | [] = corporateSelectedState
			? corporateSelectedState.campaigns
			: corporatesState.flatMap((entity: CorporatesState) => entity.campaigns)

		campaignsArray?.map((campaign: CampaignsState) => {
			if (campaign.enabled) {
				arrayCampaignOption.push({
					label: campaign.campaignName,
					value: campaign.idLogo,
				})
			}
			return campaignsArray
		})
*/
		setCampaignListOptions(arrayCampaignOption)
	}, [corporatesState, corporateSelectedState, filterCorporate])

	useEffect(() => {
		if (!corporatesState) return

		/*
		const campaignsAllArray: CampaignsState[] | [] = corporateSelectedState
			? corporateSelectedState.campaigns
			: corporatesState.flatMap((entity: CorporatesState) => entity.campaigns)

			*/
		let campaignsArray: CampaignsState[] = []
		if (filterCorporate) {
			const item = corporatesState?.find(
				(entry) => entry.id === filterCorporate
			)
			if (item) {
				campaignsArray = item.campaigns
			}
		} else {
			return
		}

		const campaignElement: CampaignsState | undefined = campaignsArray?.find(
			(campaign: CampaignsState) => campaign.idLogo === filterCampaign
		)

		setCampaignOptionSelected(
			campaignElement
				? {
						label: campaignElement?.campaignName,
						value: campaignElement?.idLogo,
					}
				: null
		)
	}, [corporatesState, filterCampaign, filterCorporate])

	return (
		<Autocomplete
			disablePortal
			id="combo-box-campaigns"
			isOptionEqualToValue={(option, value) => option.value === value?.value}
			value={campaignOptionSelected}
			onInputChange={(
				event: SyntheticEvent<Element, Event>,
				value: string,
				reason: AutocompleteChangeReason
			) => {
				if (reason === "clear") {
					setFilterCampaign(undefined)
					return
				}
			}}
			inputValue={campaignOptionSelected?.label || ""}
			options={campaignListOptions}
			sx={{ width: "100%", minWidth: "140px" }}
			renderInput={(params) => (
				<TextField
					{...params}
					label={t("campaign.label", { ns: "common" })}
					InputLabelProps={{ shrink: true }}
					variant="standard"
				/>
			)}
			onChange={(
				event: SyntheticEvent<Element, Event>,
				value: { label: string; value: string } | null,
				_reason: AutocompleteChangeReason
			) => {
				setFilterCampaign(value?.value ?? undefined)
			}}
			placeholder={t("campaign.placeholder", { ns: "common" })}
		/>
	)
}

export default CampaignAutoComplete
